import AuthGeneric from "./auth";

export default function App() {
  return <AuthGeneric/>
}
